import { Icon } from "../components/Icon";

/**
 * The end of a request: the page its form was on is gone because the request ended, not because something broke.
 * `answered` is whether this page took the answer; otherwise it expired, or was answered or withdrawn elsewhere.
 * `conversation` is whether the owner can read the conversation it was raised in. When it is not (a schedule's), the
 * Agent's progress shows in its workspace and that is where the button leads; a conversation that is empty to the
 * owner is not somewhere to say it will show.
 */
export function RequestSent({ answered, conversation = true, onContinue }: {
  answered: boolean; conversation?: boolean; onContinue: () => void;
}) {
  return <div role="status" className="agent-home-empty request-sent">
    <Icon name="done" size={26} />
    <h1>{answered ? "已发给 IP" : "这个请求已经结束"}</h1>
    <p>{conversation ? answered ? "它会接着做，有进展会回到对话里。" : "结果在对话里。"
      : answered ? "它会接着做，进展会显示在工作区里。" : "它的进展在工作区里。"}</p>
    <button className="btn" type="button" onClick={onContinue}>{conversation ? "回到对话" : "去工作区"}</button>
  </div>;
}
